import React, { Component }        from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'
import NoResult                    from '../../../components/NoResult'
import ProfessionItem              from './ProfessionItem'
import Search                      from '../../../components/Search'
import { getProfession }           from '../../../api/profession'
import Catgory                     from './Catgory'
import Classify                    from './Classify'
import { CAT_PROFESSION, LIMIT }   from '../constants/index'

const paramReset = {
  limit: LIMIT,
  page: 1,
  _s_type: null,
  _s_category_id: null,
  _s_classifiy_id: null,
  _s_name: null,
  _s_interest_r: null,
  _s_interest_i: null,
  _s_interest_a: null,
  _s_interest_s: null,
  _s_interest_e: null,
  _s_interest_c: null,
}

class ProfessionList extends Component {

  state = {
    searchVal: '',
    lastPage: false,
    searchResult: [],
    param: paramReset,
    loading: false,
  }

  searchInput = null

  handleSearch(value) {
    const param = {
      _s_name: value,
    }
    this.setState({
      searchVal: value,
      loading: Boolean(value),
    })
    if (value) {
      getProfession(param).then(res => {
        this.setState({
          searchResult: res.data,
          lastPage: res.lastPage,
        })
      }).finally(() => {
        this.setState({
          loading: false,
        })
      })
    }
  }

  handleResetSearch() {
    const { history } = this.props
    this.searchInput.reset()
    history.replace(`/profession/list/category`)
  }

  renderSearchResult() {
    const { searchResult } = this.state
    const { history } = this.props
    if (Array.isArray(searchResult) && searchResult.length) {
      return (
        <div className="major-list-outter search-result">
          {searchResult.map((d, i) =>
            <ProfessionItem
              key={i}
              major={d}
              history={history}/>
          )}
        </div>
      )
    } else {
      return <NoResult
        prompt1="对不起"
        prompt2="没有匹配到合适的职业哦"
        resetBtnText="从一级类目挑选职业"
        onResetSearch={this.handleResetSearch.bind(this)}
      />
    }
  }

  render() {
    const { match } = this.props
    const { searchVal, loading } = this.state
    return (
      <div className="major-list-wrapper">
        <Search
          ref={ref => this.searchInput = ref}
          placeholder="搜索你想了解的职业"
          onSearch={this.handleSearch.bind(this)}
        />
        {searchVal && !loading
          ? this.renderSearchResult()
          : <div className="major-list-outter">
            <Switch>
              <Route path={`${match.url}/category/:id`}
                     render={props => <Classify type={CAT_PROFESSION} {...props} />}/>
              <Route path={`${match.url}/category`} render={props => <Catgory type={CAT_PROFESSION} {...props} />}/>
              <Redirect exact from={match.url} to={`${match.url}/category`}/>
            </Switch>
          </div>
        }
      </div>
    )
  }
}


export default ProfessionList



// WEBPACK FOOTER //
// ./src/pages/Profession/List/index.js